import { Helmet } from "react-helmet-async"
import { CurrencyExchangeRatesList } from "../../../../Admin/World"

export default function CurrencyExchangeRatesListPage() {
	return (
		<>
			<Helmet>
				<title>Currency Exchange Rates</title>
			</Helmet>
			<CurrencyExchangeRatesList />
		</>
	)
}
